import React, { useState, useEffect } from 'react';
import Nav from '../Components/Nav';
import ImageGallery from '../Components/ImageGallery';
import Footer from '../Components/Footer';
import PulseLoader from "react-spinners/PulseLoader";
import Sneakpeak1 from '../Assets/sneakpeaks/City_Screenshot2.png';
import Sneakpeak2 from '../Assets/sneakpeaks/City_Screenshot3.png';
import Sneakpeak3 from '../Assets/sneakpeaks/City_Screenshot4.png';
import Sneakpeak4 from '../Assets/sneakpeaks/Lab_Spoiler1.png';
import Sneakpeak5 from '../Assets/sneakpeaks/Lab_Spoiler2.png';
import Sneakpeak6 from '../Assets/sneakpeaks/Lab_Spoiler3.png';
import { 
    MDBCard,
    MDBCardBody,
    MDBCardTitle,
    MDBContainer
 } from 'mdb-react-ui-kit';

export default function Gallery() {
    const [loading, setLoading] = useState(false);
    //  const [id, setId] = useState('');

    useEffect(() => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
        }, 4000);
    }, []);

    const images = [
        {img: Sneakpeak1},
        {img: Sneakpeak2},
        {img: Sneakpeak3},
        {img: Sneakpeak4},
        {img: Sneakpeak5},
        {img: Sneakpeak6},
    ]

    return ( 

        <MDBContainer fluid className='text-center text-black mt-5'>
            <Nav />
                <MDBCard alignment='center' className='zoomIn mx-auto mt-5' style={{width: '85vw', backgroundColor: 'rgba(120, 120, 120, .5)', border: '1px solid rgba(168, 168, 168, .5)', borderRadius: '10px'}}>
                    <MDBCardBody>
                        <MDBCardTitle className='mb-4'>Videos</MDBCardTitle>
                            <iframe 
                                className="d-none d-md-block mb-5 mx-auto video" 
                                width="70%" 
                                height="450" 
                                src="https://www.youtube.com/embed/hicnMBsk3ms" 
                                title="YouTube video player"
                                frameBorder="0" 
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                                allowFullScreen>     
                            </iframe>
                            <iframe 
                                className="d-block d-md-none d-sm-block mb-5 mx-auto video"
                                width="100%" 
                                height="250"
                                src="https://www.youtube.com/embed/hicnMBsk3ms" 
                                title="YouTube video player" 
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                                allowFullScreen>     
                            </iframe>
                        <MDBCardTitle className="mb-4">Gallery</MDBCardTitle>
                            {loading ? 
                                <PulseLoader color="#5d5d5d" />
                                :
                                <ImageGallery images={images} />
                            }                      
                    </MDBCardBody>
                </MDBCard>
            <Footer className="pt-5" />
        </MDBContainer>
    );
}